import { ArticleMeta } from 'types/blog';

// ==============================|| 記事のメタ ||============================== //
//
// 一覧・カテゴリ一覧・関連記事のカードは、このファイルだけを読む。
// 本文(同名の .ts)と分けているのは、一覧を描くのに全記事の本文まで
// JSバンドルへ入れないため(詳しくは src/const/blog/registry.ts)。
//
// ★ ここに本文を書かないこと。書いた瞬間、一覧がそれを読み込むようになる。

export const meta: ArticleMeta = {
    slug: 'shintai-kousoku-mijisshi-gensan',
    title: '身体拘束廃止未実施減算｜拘束がなくても記録がなければ1%減',
    description:
        '身体拘束廃止未実施減算で判定されているのは、身体拘束をしたかどうかではなく記録があるかどうかです。記録・身体拘束適正化検討委員会・指針の整備・研修という4つの要件、虐待防止措置未実施減算との違い、拘束がなかった月の記録と緊急やむを得ない場合の記録の文例を、通知の原文つきで整理しました。',
    excerpt:
        'うちは身体拘束をしていないから関係ない——この減算でいちばん多い思い違いです。通知が見ているのは拘束の有無ではなく、記録の有無のほうです。',
    category: '運営指導',
    keywords: [
        '身体拘束廃止未実施減算',
        '身体拘束 記録 放課後等デイサービス',
        '身体拘束適正化検討委員会',
        '身体拘束等の適正化のための指針',
        '切迫性 非代替性 一時性'
    ],
    publishedAt: '2026-08-06',
    updatedAt: '2026-08-31',
};
